import { Component, Vue } from "vue-property-decorator";

import { ApiResult } from "@timesheets/common";
import Errors from "Components/Errors.vue";
import { GemmaError } from "@gemma/errors";
import { IHasSubmitApiRequest } from "./IHasSubmitApiRequest";
import { INotify } from "./INotify";
import { INotifyOptions } from "./INotifyOptions";
import { ISubmitApiRequest } from "@timesheets/webapp-support";
import { RecordAny } from "@gemma/typescript-types";
import { routeAsApiUrl } from "@gemma/api-common";
import { submit } from "./submit";

@Component({
  components: {
    Errors,
  },
})
export class Form<
  //
  TFormData extends RecordAny,
  TApiRequestData,
  TResponseData,
  TFailureResponseData
> extends Vue implements INotify<TFormData, TFailureResponseData>, IHasSubmitApiRequest<TFormData, TApiRequestData, TResponseData, TFailureResponseData> {
  notify?: INotifyOptions<TFormData, TFailureResponseData> | undefined;
  submitApiRequest?: ISubmitApiRequest<TFormData, TApiRequestData, TResponseData, TFailureResponseData>;
  route!: string;
  action!: string;
  errors: GemmaError[] = [];
  requestSucceeded: boolean = false;
  submitting: boolean = false;
  validated: boolean = false;
  warnings: GemmaError[] = [];
  form!: TFormData;
  doSubmit?: boolean = true;

  created() {
    if (!this.action && this.route) {
      this.action = routeAsApiUrl(this.route, this.$app.api.rootUrl);
    }
  }

  async submit(event: Event): Promise<ApiResult<TResponseData, TFailureResponseData> | undefined> {
    event.preventDefault();

    if (this.doSubmit) {
      return submit.call<Form<TFormData, TApiRequestData, TResponseData, TFailureResponseData>, [Event], Promise<ApiResult<TResponseData, TFailureResponseData> | undefined>>(this, event);
    } else {
      this.requestSucceeded = true;
      const OnSuccess = <{ onSuccess?(_data?: TResponseData): Promise<void> }>this;
      if (typeof OnSuccess.onSuccess === "function") {
        await OnSuccess.onSuccess.call(this);
      }

      const Onsuccess = <{ success?(_data?: TResponseData): Promise<void> }>this;
      if (typeof Onsuccess.success === "function") {
        await Onsuccess.success.call(this);
      }
      return undefined;
    }
  }
}
